export const GUARANTEE_CC = {
  EXISTING: 'existing',
  NEW: 'new'
};
